interface ConsentPdfViewerProps {
  className?: string;
  fallbackClassName?: string;
}

const CONSENT_PDF_URL = 'https://drive.google.com/file/d/15Mnd7X5qQ1weuCninjZKkg2xZp7eM3SO/preview';

export function ConsentPdfViewer({ className, fallbackClassName }: ConsentPdfViewerProps) {
  return (
    <object
      data={CONSENT_PDF_URL}
      type="application/pdf"
      width="100%"
      height="350px"
      className={className}
      aria-label="Voluntary Consent to Receive Documents Electronically"
    >
      <p className={fallbackClassName}>
        Your browser doesn&apos;t support PDFs. <a href={CONSENT_PDF_URL}>Download the PDF</a>
      </p>
    </object>
  );
}
